<template>
  <div class="feedback-modal-overlay" @click="$emit('close')">
    <div class="feedback-modal" @click.stop>
      <div class="modal-header">
        <h2>Submit Feedback</h2>
        <button class="close-button" @click="$emit('close')">&times;</button>
      </div>
      <div class="modal-body">
        <textarea
          v-model="feedbackText"
          placeholder="Share your thoughts, suggestions, or issues..."
          rows="6"
        ></textarea>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" @click="$emit('close')">Cancel</button>
        <button
          class="btn btn-primary"
          @click="submitFeedback"
          :disabled="!feedbackText.trim()"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const feedbackText = ref('');

const emit = defineEmits<{
  (e: 'close'): void;
  (e: 'submit', feedback: string): void;
}>();

const submitFeedback = () => {
  if (feedbackText.value.trim()) {
    emit('submit', feedbackText.value);
    feedbackText.value = '';
  }
};
</script>

<style scoped>
.feedback-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10002;
  pointer-events: auto;
}
.feedback-modal {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}
.modal-header {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-header h2 {
  margin: 0;
  font-size: 18px;
}
.close-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}
.modal-body {
  padding: 20px;
}
.modal-body textarea {
  width: 100%;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  resize: vertical;
}
.modal-footer {
  padding: 15px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.btn-primary {
  background-color: #007bff;
  color: white;
}
.btn-primary:disabled {
  background-color: #a0c3e3;
}
.btn-secondary {
  background-color: #6c757d;
  color: white;
}
</style>
